/*地图样式文件style*/
let state={
  style:null
};
let mutations={
  patch_style(state,style){
    state.style = style
  }
};

let getters={
  style:state => () =>  JSON.parse(JSON.stringify(state.style)),
}
export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/mapstyle.js